// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsLinkRow} from '@app/features/app/components/dialogs/shared/SettingsRow';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import {DownloadSimpleIcon} from '@app/features/ui/icons/Icons';
import {
	DataRequestModal,
	EXPORT_TAB_DESCRIPTION,
} from '@app/features/user/components/modals/tabs/privacy_safety_tab/data_request_modal/DataRequestModal';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useCallback} from 'react';

export const DataExportTabContent: React.FC = observer(() => {
	const {i18n} = useLingui();
	const handleOpen = useCallback(() => {
		ModalCommands.push(
			modal(() => (
				<DataRequestModal variant="export" data-flx="user.privacy-safety-tab.data-export-tab.data-request-modal" />
			)),
		);
	}, []);
	return (
		<SettingsLinkRow
			icon={<DownloadSimpleIcon size={20} />}
			title={<Trans>Export my data</Trans>}
			description={i18n._(EXPORT_TAB_DESCRIPTION)}
			onClick={handleOpen}
			data-flx="user.privacy-safety-tab.data-export-tab.data-export-tab-content.button.open-modal"
		/>
	);
});
